import React from "react";
import {Card, CardActionArea, CardContent, Typography} from "@mui/material";
import {SvgIconComponent} from "@mui/icons-material";
import classes from '../../styling/components/UserDashboard.module.css';

interface Props {
    title: string;
    description: string;
    icon: SvgIconComponent;
    onClick: () => void;
}

export const FeatureCard: React.FC<Props> = ({ title, description, icon: Icon, onClick }) => {
    return (
        <Card className={`${classes.card} ${classes.featureCard}`}>
            <CardActionArea 
                className={classes.featureCardAction} 
                onClick={onClick}
            >
                <CardContent className={classes.cardContent}>
                    <div className={classes.cardLayout}>
                        <div className={classes.contentArea}>
                            <div className={classes.titleContainer}>
                                <Typography variant="h6" component="h3" className={classes.title}>
                                    {title}
                                </Typography>
                            </div>
                            <Typography variant="body2" color="text.secondary" className={classes.content}>
                                {description}
                            </Typography>
                        </div>
                        <div className={classes.imageArea}>
                            <Icon className={classes.featureIcon} />
                        </div>
                    </div>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

